import { createSlice } from "@reduxjs/toolkit";
import { getFrameworksList } from "./thunk";

const getFrameworksListSlice = createSlice({
    name: "getFrameworksListSlice",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFrameworksList.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(getFrameworksList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getFrameworksList.rejected, (state) => {
                state.isError = true;
                state.isLoading = false;
            })
    }
});

export default getFrameworksListSlice.reducer;